<div class="loginRegisterScreen">
  <div class="loginRegisterScreen__content">
    <div class="vc-title-s loginRegisterScreen__content__registerOffer" i18n="@@AUTH.REGISTER_OFFER">
      Register to get {{ promoOffer }} off
    </div>
    <p class="loginRegisterScreen__content__intro" i18n="@@AUTH.REGISTER_INTRO">
      Buy, sell and unlock more: Save favourite items, track price drops & make offers!
    </p>
    <div class="loginRegisterScreen__content__actions">
      <vc-facebook-connect
        class="vc-btn vc-btn--full vc-btn--large loginRegisterScreen__content__actions__register"
        [type]="'login'"
        [registerScreen]="true"
        (registerNextStep)="setUserFromFacebook($event)"
      ></vc-facebook-connect>
      <button
        class="loginRegisterScreen__content__actions__register vc-btn vc-btn--full vc-btn--large vc-btn--outline"
        (click)="this.switchTo('register')"
        i18n="@@AUTH.REGISTER.EMAIL"
      >
        Continue with Email
      </button>
      <div class="loginRegisterScreen__content__actions__login vc-text-m" i18n="@@AUTH.SWITCH.LOGIN.ACCOUNT">
        Already have an account ?
        <button class="loginRegisterScreen__content__actions__login__button" (click)="this.switchTo('login')">
          Log in
        </button>
      </div>
    </div>
  </div>
  <button
    (click)="closePopin()"
    class="vc-btn vc-btn--primary vc-btn--small loginRegisterScreen__guestButton"
    i18n="@@MODAL.BUTTON.GUEST"
    [mat-dialog-close]
  >
    Continue as guest
  </button>
</div>
